export * from './analytics';
export * from './attributes';
export * from './browser';
export * from './buildUrl';
export * from './colors';
export * from './colorScales';
export * from './component';
export * from './coordinateComputation';
export * from './dashedLine';
export * from './emissions';
export * from './errorBoundary';
export * from './featureHelpers';
export * from './fetch';
export * from './getSortedUniqueStrings';
export * from './internationalization';
export * from './layerIds';
export * from './localStorage';
export * from './numbers';
export * from './mapClick';
export * from './pickInfo';
export * from './scales';
export * from './stac';
export * from './stringFormatters';
export * from './time';
export * from './rasterOpacity';
export * from './reducerHelpers';
export * from './queryStringHelpers';
export * from './infoToSelectedFeature';
export * from './urlValidators';

/**
 * Normalizes a Next.js route prop to always return a string.
 * For Next.js catch-all routes, only the most relevant part of the array is returned.  For example,
 * a page under `pages/some-page/[...entityId].tsx` would have an input of ['some-page', 'some-deeper-page'],
 * and would output 'some-deeper-page'.
 * See https://nextjs.org/docs/routing/dynamic-routes
 */
export const normalizeNextRouteProp = (id: string | string[] | undefined): string => {
    return Array.isArray(id) ? id[id.length - 1] : id || '';
};
